<template>
    <div class="content-container border-alert-inset">
        <div class="font-weight-600 text-h6"><v-icon icon="mdi-alert" color="primary-dark"></v-icon> Inscription en
            tant
            qu'administrateur</div>

        <div class="mb-1"> Vous êtes connecté en tant qu'administrateur sur ce formulaire d'inscription. Vous avez la
            possibilité
            d'inscrire des coureurs sans les limitations d'inscrits sur les courses. A l'issue du formulaire vous
            pourrez renseigner les modalités de paiement externe
            (chèque,espèces,virement,invité..)</div>
        <SportipsButton icon="mdi-close" :href="'/inscription/' + mainStore.module.base + '/'">
            Quitter
            le mode
            administrateur
        </SportipsButton>
    </div>

</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
export default {
    computed: {
        ...mapStores(useMainStore)
    }

}
</script>

<style lang="scss" scoped></style>